import { render } from "./FooterMenu.vue?vue&type=template&id=5a5f0d40&scoped=true&style=color%3A%20var(--primary-color)%3B%20background-color%3A%20var(--primary-color)%3B"
import script from "./FooterMenu.vue?vue&type=script&lang=js"
export * from "./FooterMenu.vue?vue&type=script&lang=js"

import "./FooterMenu.vue?vue&type=style&index=0&id=5a5f0d40&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a5f0d40"]])

export default __exports__